import { background, color } from "@chakra-ui/system";
import { CONSTANTS } from "config/constant";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import ProfileImage from "../../../../assets/img/orders/orderDetail/userplace.png";
import { Card, Collapse } from "antd";
import { useTranslation } from "react-i18next";
const { Panel } = Collapse;

const ViewUser = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const data = location.state && location.state.data;
  const {t} = useTranslation();
  function truncateText(text, maxLength) {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  }

  console.log(data, "fadhslfhasldfjaleyrfhlkajn,n");
  return (
    <div className="flex gap-8">
      <div style={styles.container}>
        <table style={styles.table}>
          <tbody>
            <div
              className="flex cursor-pointer items-center gap-2"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MdOutlineArrowBack
                className="cursor-pointer"
                style={{ fontSize: "17px" }}
              />
              <p>{t("Back")}</p>
            </div>
            <p className="mb-4 text-center text-[20px] font-bold  ">
              {t("View User")}
            </p>
            <hr className="mb-4" />
            <div className="mb-3 flex w-full justify-center">
              <tr className="flex flex-col items-center justify-center">
                <td className="">
                  <img
                    src={
                      data?.profile_image?.[0]?.file_url
                        ? CONSTANTS?.IMG_DIRECTORY +
                          data?.profile_image?.[0]?.file_url
                        : ProfileImage
                    }
                    alt=""
                    style={{
                      width: "8rem",
                      height: "8rem",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </td>
                <td className="w-[12rem]"></td>
              </tr>
              {/* <tr className="flex flex-col">
                <td className="w-[12rem]"></td>
                <td className="w-[12rem]"></td>
              </tr>
              <tr className="flex flex-col">
                <td className="w-[12rem]"></td>
                <td className="w-[12rem]"></td>
              </tr>{" "} */}
            </div>
            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Name")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.first_name + " " + data?.last_name}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Email")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">{data?.email}</td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  {t("Phone Number")}
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.phone_no}
                </td>
              </tr>
              {data?.current_membership_plan?.plan_title && (
                <tr className="flex flex-col">
                  <td
                    className="font-lighht w-[12rem] text-[14px] font-bold"
                    style={styles.label}
                  >
                    {t("Membership Plan")}
                  </td>
                  <td className="w-[12rem] pl-4 text-[14px] ">
                    {data?.current_membership_plan?.plan_title}
                  </td>
                </tr>
              )}
            </div>
            {/* <div className="mb-3 flex justify-around">
        
              <tr className="flex flex-col">
                <td
                  className="w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  Location
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.address?.map((element, idx) => (
                    <p title={element?.location} key={element?._id}>
                      • {element?.location ?? "--"}
                    </p>
                  ))}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  Additional Directions
                </td>
                <td className="w-[12rem] pl-4 text-[14px]  ">
                  {data?.address?.some(
                    (element) => element?.additional_directions
                  ) ? (
                    data?.address?.map((element, idx) =>
                      element?.additional_directions ? (
                        <p
                          title={element?.additional_directions}
                          key={element?._id}
                        >
                          <div>• {element?.additional_directions}</div>
                        </p>
                      ) : null
                    )
                  ) : (
                    <p>---</p>
                  )}
                </td>
              </tr>

              <tr className="flex flex-col">
                <td
                  className="w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  Building
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.address?.some(
                    (element) => element?.building
                  ) ? (
                    data?.address?.map((element, idx) =>
                      element?.building ? (
                        <p
                          title={element?.building}
                          key={element?._id}
                        >
                          <div>• {element?.building}</div>
                        </p>
                      ) : null
                    )
                  ) : (
                    <p>---</p>
                  )}
                </td>
              </tr>
            </div>

            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="w-[12rem] text-[14px]  font-bold"
                  style={styles.label}
                >
                  Appartment
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.address?.some(
                    (element) => element?.apartment
                  ) ? (
                    data?.address?.map((element, idx) =>
                      element?.apartment ? (
                        <p
                          title={element?.apartment}
                          key={element?._id}
                        >
                          <div>• {element?.apartment}</div>
                        </p>
                      ) : null
                    )
                  ) : (
                    <p>---</p>
                  )}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="w-[12rem] text-[14px] font-bold "
                  style={styles.label}
                >
                  Floor
                </td>
                <td className="w-[12rem] pl-4 text-[14px] ">
                  {data?.address?.some(
                    (element) => element?.floor
                  ) ? (
                    data?.address?.map((element, idx) =>
                      element?.floor ? (
                        <p
                          title={element?.floor}
                          key={element?._id}
                        >
                          <div>• {element?.floor}</div>
                        </p>
                      ) : null
                    )
                  ) : (
                    <p>---</p>
                  )}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  Street
                </td>
                <td className="w-[12rem] pl-4 text-[14px]  ">
                  {data?.address?.some(
                    (element) => element?.street
                  ) ? (
                    data?.address?.map((element, idx) =>
                      element?.street ? (
                        <p
                          title={element?.street}
                          key={element?._id}
                        >
                          <div>• {element?.street}</div>
                        </p>
                      ) : null
                    )
                  ) : (
                    <p>---</p>
                  )}
                </td>
              </tr>
            </div>
            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  City
                </td>
                <td className="w-[12rem] pl-4 text-[14px]  ">
                  {data?.address?.some(
                    (element) => element?.city
                  ) ? (
                    data?.address?.map((element, idx) =>
                      element?.city ? (
                        <p
                          title={element?.city}
                          key={element?._id}
                        >
                          <div>• {element?.city}</div>
                        </p>
                      ) : null
                    )
                  ) : (
                    <p>---</p>
                  )}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  Province
                </td>
                <td className="w-[12rem] pl-4 text-[14px]  ">
                  {data?.address?.some(
                    (element) => element?.province
                  ) ? (
                    data?.address?.map((element, idx) =>
                      element?.province ? (
                        <p
                          title={element?.province}
                          key={element?._id}
                        >
                          <div>• {element?.province}</div>
                        </p>
                      ) : null
                    )
                  ) : (
                    <p>---</p>
                  )}
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                  Country
                </td>
                <td className="w-[12rem] pl-4 text-[14px]  ">
                  {data?.address?.some(
                    (element) => element?.country
                  ) ? (
                    data?.address?.map((element, idx) =>
                      element?.country ? (
                        <p
                          title={element?.country}
                          key={element?._id}
                        >
                          <div>• {element?.country}</div>
                        </p>
                      ) : null
                    )
                  ) : (
                    <p>---</p>
                  )}
                </td>
              </tr>
            </div>

            <div className="mb-3 flex justify-around">
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px] font-bold"
                  style={styles.label}
                >
                </td>
                <td className="w-[12rem] pl-4 text-[14px]  ">
                </td>
              </tr>

              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px]"
                  style={styles.label}
                >
                </td>
                <td className="w-[12rem] pl-4 text-[14px]  ">
                </td>
              </tr>
              <tr className="flex flex-col">
                <td
                  className="font-lighht w-[12rem] text-[14px]"
                  style={styles.label}
                >
                </td>
                <td className="w-[12rem] pl-4 text-[14px]  ">
                </td>
              </tr>
            </div> */}

            {data?.address?.map((element, idx) => (
              <Card
                className="time-logs view-user-card"
                style={{ border: "none" }}
                // key={element?._id}
                // className="mb-3-"
                // style={{ border: "1px solid #ccc" }}
              >
                <Collapse
                  // style={{ border: "none" }}
                  expandIconPosition="right" // Set the expand icon position to right
                  // className="custom-collapse" // Add a custom class for further styling
                >
                  <Panel
                    header={t(`Address`)  +" "+ idx + 1}
                    key="1"
                    style={{ border: "none" }}
                  >
                    <div className="mb-3 flex justify-around">
                      <tr className="flex flex-col">
                        <td
                          className="w-[12rem] text-[14px] font-bold"
                          style={styles.label}
                        >
                          {t("Location")}
                        </td>
                        <td className="w-[12rem] pl-4 text-[14px] ">
                          <p title={element?.location}>
                            {element?.location ?? "--"}
                          </p>
                        </td>
                      </tr>
                      <tr className="flex flex-col">
                        <td
                          className="font-lighht w-[12rem] text-[14px] font-bold"
                          style={styles.label}
                        >
                          {t("Additional Directions")}
                        </td>
                        <td className="w-[12rem] pl-4 text-[14px]  ">
                          <p title={element?.additional_directions}>
                            <div>
                              {element?.additional_directions
                                ? element?.additional_directions
                                : "---"}
                            </div>
                          </p>
                        </td>
                      </tr>

                      <tr className="flex flex-col">
                        <td
                          className="w-[12rem] text-[14px] font-bold"
                          style={styles.label}
                        >
                          {t("Building")}
                        </td>
                        <td className="w-[12rem] pl-4 text-[14px] ">
                          <p title={element?.building} key={element?._id}>
                            <div>
                              {element?.building ? element?.building : "---"}
                            </div>
                          </p>
                        </td>
                      </tr>
                    </div>

                    <div className="mb-3 flex justify-around">
                      <tr className="flex flex-col">
                        <td
                          className="w-[12rem] text-[14px]  font-bold"
                          style={styles.label}
                        >
                          {t("Appartment")}
                        </td>
                        <td className="w-[12rem] pl-4 text-[14px] ">
                          <p title={element?.apartment}>
                            <div>
                              {element?.apartment ? element?.apartment : "---"}
                            </div>
                          </p>
                        </td>
                      </tr>
                      <tr className="flex flex-col">
                        <td
                          className="w-[12rem] text-[14px] font-bold "
                          style={styles.label}
                        >
                          {t("Floor")}
                        </td>
                        <td className="w-[12rem] pl-4 text-[14px] ">
                          <p title={element?.floor} key={element?._id}>
                            <div>
                              {" "}
                              {element?.floor ? element?.floor : "---"}
                            </div>
                          </p>
                        </td>
                      </tr>
                      <tr className="flex flex-col">
                        <td
                          className="w-[12rem] text-[14px] font-bold"
                          style={styles.label}
                        >
                          {t("Street")}
                        </td>
                        <td className="w-[12rem] pl-4 text-[14px]  ">
                          <p title={element?.street} key={element?._id}>
                            <div>
                              {element?.street ? element?.street : "---"}
                            </div>
                          </p>
                        </td>
                      </tr>
                    </div>
                    <div className="mb-3 flex justify-around">
                      <tr className="flex flex-col">
                        <td
                          className="w-[12rem] text-[14px] font-bold"
                          style={styles.label}
                        >
                          {t("City")}
                        </td>
                        <td className="w-[12rem] pl-4 text-[14px]  ">
                          <p title={element?.city} key={element?._id}>
                            <div>{element?.city ? element?.city : "---"}</div>
                          </p>
                        </td>
                      </tr>
                      <tr className="flex flex-col">
                        <td
                          className="w-[12rem] text-[14px] font-bold"
                          style={styles.label}
                        >
                          {t("Province")}
                        </td>
                        <td className="w-[12rem] pl-4 text-[14px]  ">
                          <p title={element?.province} key={element?._id}>
                            <div>
                              {element?.province ? element?.province : "---"}
                            </div>
                          </p>
                        </td>
                      </tr>
                      <tr className="flex flex-col">
                        <td
                          className="w-[12rem] text-[14px] font-bold"
                          style={styles.label}
                        >
                          {t("Country")}
                        </td>
                        <td className="w-[12rem] pl-4 text-[14px]  ">
                          <p title={element?.country} key={element?._id}>
                            <div>
                              {element?.country ? element?.country : "---"}
                            </div>
                          </p>
                        </td>
                      </tr>
                    </div>

                    <div className="mb-3 flex justify-around">
                      <tr className="flex flex-col">
                        <td
                          className="font-lighht w-[12rem] text-[14px] font-bold"
                          style={styles.label}
                        ></td>
                        <td className="w-[12rem] pl-4 text-[14px]  "></td>
                      </tr>

                      <tr className="flex flex-col">
                        <td
                          className="font-lighht w-[12rem] text-[14px]"
                          style={styles.label}
                        ></td>
                        <td className="w-[12rem] pl-4 text-[14px]  "></td>
                      </tr>
                      <tr className="flex flex-col">
                        <td
                          className="font-lighht w-[12rem] text-[14px]"
                          style={styles.label}
                        ></td>
                        <td className="w-[12rem] pl-4 text-[14px]  "></td>
                      </tr>
                    </div>
                  </Panel>
                </Collapse>
              </Card>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
// style={{ background: "#e5e2e2" }}

const styles = {
  container: {
    margin: "auto",
    width: "80%",
    padding: "20px",
    background: "white",
    borderRadius: "8px",
    boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
  },
  label: {
    paddingRight: "10px",
    verticalAlign: "top",
    padding: "1rem",
  },
};

export default ViewUser;
